import React from 'react';
import { LinkButton } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
import { aboutImage, contact } from '../../data/site';
export function About() {
  return <section id="sobre-mi" className="bg-cream py-20 lg:py-32" data-id="element-23" data-mp="12qwxqy85du5b">
      <div className="mx-auto grid max-w-shell items-start gap-14 px-5 lg:grid-cols-[45fr_55fr] lg:gap-20 lg:px-10" data-id="element-24" data-mp="12qdijp9vtjuz">
        <Reveal className="relative" data-id="element-25" data-mp="yn7acc37lilv">
          <div className="aspect-[4/5] overflow-hidden rounded-[28px] bg-sand shadow-soft" data-id="element-26" data-mp="az7nhn90qcck">
            <img src={aboutImage} alt="Andrea Báez Graterol atendiendo a un cliente por teléfono" className="h-full w-full object-cover object-[center_25%]" width={1440} height={2560} data-id="element-27" data-mp="616574jf2h25" />
          </div>
          <div className="relative z-10 -mt-12 ml-6 mr-6 rounded-[20px] border border-navy/[0.07] bg-white p-6 shadow-lift lg:ml-10 lg:mr-0" data-id="element-28" data-mp="3nh4fgqq0qsew">
            <p className="font-display text-[13px] font-semibold tracking-[0.12em] text-navy" data-id="element-29" data-mp="3jehi6aakwfab">
              {contact.name.toUpperCase()}
            </p>
            <p className="mt-1.5 text-[13px] font-light text-ink/60" data-id="element-30" data-mp="388bjbnjypx8b">{contact.title}</p>
            <p className="mt-3 border-t border-navy/[0.07] pt-3 eyebrow text-gold" data-id="element-31" data-mp="385yssm052ejn">
              {contact.npn}
            </p>
          </div>
        </Reveal>

        <div data-id="element-32" data-mp="3hwthry4rrs8s">
          <Reveal data-id="element-33" data-mp="3hxczbdqicema">
            <p className="eyebrow mb-5 text-teal" data-id="element-34" data-mp="3hzz6hc9hks3z">Conoce a Andrea</p>
            <h2 className="font-display text-[2rem] font-semibold leading-[1.15] tracking-[-0.02em] text-navy sm:text-[2.6rem] lg:text-[3rem]" data-id="element-35" data-mp="2kbxg6lu373mh">
              Más que una póliza,
              <br data-id="element-36" data-mp="2u7io10lu6y45" />
              <span className="text-teal" data-id="element-37" data-mp="2u6z5bhod45p2">una decisión para proteger tu futuro.</span>
            </h2>
          </Reveal>

          <Reveal delay={0.08} className="mt-7 space-y-5 text-[15px] font-light leading-relaxed text-ink/70" data-id="element-38" data-mp="2z5k7hmn6czg5">
            <p data-id="element-39" data-mp="9kns2aoi0p2r">
              Soy Andrea Báez Graterol, asesora de seguros enfocada en ayudar a personas y
              familias a entender mejor sus opciones de protección.
            </p>
            <p data-id="element-40" data-mp="2amnahfjqc07z">
              Mi objetivo es hacer que el proceso de elegir un seguro sea más claro, sencillo
              y personalizado.
            </p>
            <p data-id="element-41" data-mp="2jk7h740d2opz">
              Trabajo con diferentes compañías para poder evaluar distintas alternativas
              según las necesidades, situación y objetivos de cada persona.
            </p>
            <p data-id="element-42" data-mp="1rv4a7gh3b09n">
              Creo que una buena asesoría comienza escuchando. Por eso, antes de hablar de una
              póliza, quiero conocer qué es importante para ti y ayudarte a entender qué
              opciones pueden estar disponibles.
            </p>
          </Reveal>

          <Reveal delay={0.12} data-id="element-43" data-mp="1vv4sjc7b7vlz">
            <blockquote className="mt-9 border-l-2 border-gold pl-6" data-id="element-44" data-mp="1vu3ecyuzyt01">
              <p className="font-display text-[18px] font-medium italic leading-relaxed text-navy sm:text-[20px]" data-id="element-45" data-mp="185ac6kns7owz">
                “Tu protección merece una estrategia, no una decisión apresurada.”
              </p>
            </blockquote>
            <LinkButton href="#agenda" size="lg" className="mt-9 w-full sm:w-auto" data-id="element-46" data-mp="tz8r8s40extj">
              HABLEMOS SOBRE TU PROTECCIÓN
            </LinkButton>
          </Reveal>
        </div>
      </div>
    </section>;
}